var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zhizhao"},[_c('h3',[_vm._v("走进麦克林")]),_c('div',{staticStyle:{"width":"876px","height":"505px"},domProps:{"innerHTML":_vm._s(_vm.list.content)}},[_vm._v(_vm._s(_vm.list.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }